angular.module('impactx.comments').directive('appMixedComments', function ($timeout, $mdColors, themeFactory) {
    return {
        scope: {
            commentDto: "=",
            readOnly: "=",
            validationForm: "=",
            fullWidth: "=",
            useCommentTable: "=",
            allCommentsDeletable: "=",
            supplierAlias: "=",
            showAvatar: "=",
            sendIcon: "@",
            attachmentButtonLabel: '@',
            onCommentAdded: '&',
            onAttachmentAdded: '&',
            onCommentRemoved: '&'
        },
        controller: "MixedCommentCtrl",
        controllerAs: "commentCtrl",
        restrict: 'E',
        templateUrl: 'shared/comments/mixed-comments.html',
        transclude: true,
        link: link
    };

    function link(scope, element, attrs, ctrl) {
        var dragCounter = 0,
            tokenWatcher = scope.$watch(function () {
                    return scope.commentDto;
                },
                function (newValue) {
                    if (newValue && newValue.commentToken) {
                        $timeout(function () {
                            scope.checkAttachmentRequired();
                            angular.element(document.querySelector('#fileInput' + newValue.commentToken.replace(/([.])/g, '\\$1'))).on('change', ctrl.handleFileSelect);
                        }, 0);

                        tokenWatcher();
                    }
                }
            );

        if (scope.commentDto && scope.commentDto.attachmentsAllowed) {
            scope.$watch("readOnly", function (newValue) {
                if (!newValue) {
                    element.on('drop', function (e) {
                        var dropZoneBox = angular.element(element[0].getElementsByClassName("dropzone-comment"));

                        dropZoneBox.css('background-color', '');
                        dropZoneBox.css('border-color', 'rgba(0, 0, 0, 0)');
                        e.preventDefault();
                        var file = e.originalEvent.dataTransfer.files[0];
                        ctrl.handleFile(e, file);
                        dragCounter = 0;
                    });

                    element.on('dragover', function (e) {
                        e.originalEvent.dataTransfer.dropEffect = "copy";
                        e.preventDefault();
                    });

                    element.on('dragenter', function (e) {
                        var dropZoneBox;
                        dragCounter++;

                        if (dragCounter === 1) {
                            dropZoneBox = angular.element(element[0].getElementsByClassName("dropzone-comment"));

                            dropZoneBox.css('background-color', 'rgba(229, 229, 229, .5)');
                            dropZoneBox.css('border-color', $mdColors.getThemeColor(themeFactory.getTheme() + "-primary-300"));
                        }
                        e.originalEvent.dataTransfer.dropEffect = "copy";
                        e.preventDefault();
                    });

                    element.on('dragleave', function (e) {
                        var dropZoneBox;
                        dragCounter--;

                        if (dragCounter <= 0) {
                            dropZoneBox = angular.element(element[0].getElementsByClassName("dropzone-comment"));

                            dropZoneBox.css('background-color', '');
                            dropZoneBox.css('border-color', 'rgba(0, 0, 0, 0)');
                        }
                        e.originalEvent.dataTransfer.dropEffect = "none";
                        e.preventDefault();
                    });

                    element.on('dragend', function (e) {
                        var dropZoneBox = angular.element(element[0].getElementsByClassName("dropzone-comment"));

                        dropZoneBox.css('background-color', '');
                        dropZoneBox.css('border-color', 'rgba(0, 0, 0, 0)');
                        e.originalEvent.dataTransfer.dropEffect = "none";
                        e.preventDefault();
                        dragCounter = 0;
                    });
                }
                else {
                    element.off("drop dragover dragenter dragleave dragend");
                }
            });
        }

        scope.$on("$destroy", function () {
            element.off("drop dragover dragenter dragleave dragend");
        });
    }

    // e.ctrlKey && e.keyCode == 13
});